import React from 'react';
import * as PropTypes from 'prop-types';
import actHealthLogo from '@assets/images/logo/act-health-logo.png';
import edenLogo from '@assets/images/logo/eden-logo.png';
import logotypeVertical from '@assets/images/logo/logotype-vertical.png';
import logotypeWhite from '@assets/images/logo/logotype-white-512-512.png';

import { ON_PREMISE_INSTANCES } from '$app-web/constants';
import { getEnvironmentName } from '$app-web/utils';

import classes from './styles.module.scss';

const Logo = (props) => {
    const { color } = props;
    const defaultLogoSource = color === 'white' ? logotypeWhite : logotypeVertical;

    const environmentName = getEnvironmentName();

    let logoSource;
    switch (environmentName) {
        case ON_PREMISE_INSTANCES.ACT:
            logoSource = actHealthLogo;
            break;
        case ON_PREMISE_INSTANCES.EDEN:
            logoSource = edenLogo;
            break;
        default:
            logoSource = defaultLogoSource;
            break;
    }

    return (
        <div className={classes.logoWrapper}>
            <img src={logoSource} alt="Logo" className={classes.logo} />
        </div>
    );
};

Logo.defaultProps = {
    color: 'color',
};

Logo.propTypes = {
    color: PropTypes.oneOf(['white', 'color']),
};

export default Logo;
